import React from 'react';
import Redo from '../App/Redo';
import { Link } from 'react-router-dom';

import Banner from '../App/Banner';

import Check from '../../assets/check.svg'
import PrestationUE from '../../assets/categories/PrestationUE.png'
import VADUE from '../../assets/categories/VADUE.png'
import Arrow from '../../assets/arrow.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function FranceToUELess10K() {
  return(
    <div>
      <Banner />
      <div id="FranceToFrance" className='paper'>
        <Link to='/FranceToUE'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
        </Link>
        <div className="breadcrumbs">
          <p><img src={Check} />Votre stock se situe en France</p>
          <p><img src={Check} />Vous vendez vers l'Union Européenne</p>
          <p><img src={Check} />Vous réalisez moins de 10 000 € en UE (hors France)</p>
        </div>
        <h4>La procédure :</h4>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Appliquez le taux de TVA français</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Déclarez la TVA en France</ul>

        <div className="when">
          <h4>ATTENTION :</h4>
          <p>Si vous déplacez votre stock en Europe (via Amazon par exemple), vous devrez déclarer la TVA sur le guichet unique OSS (et non en France), dès 1 euro !</p>
        </div>

        <hr />
        <div className='categorie' >
          <h3>Si vous êtes client Dougs :</h3>
          <div className='FranceUE'>
            <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Pour les prestations de services, sélectionnez la catégorie ci-dessous :</ul>
            <img src={PrestationUE} alt='categorie prestation' />
          </div>
          <div className='FranceUE'>
            <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Pour la vente de marchandises, sélectionnez la catégorie ci-dessous :</ul>
            <img src={VADUE} alt='catégorie VAD' />
          </div>
        </div>
        <div className="button">
          <Redo />
        </div>
      </div>
    </div>
  )
}

export default FranceToUELess10K